import type { Product } from '../../../data/product';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const Barcode: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Barcode',
  minWidth: 100,
  maxWidth: 128,
  accessorFn: (product) => product.barcode,
});
